import { App } from '@app/app';
import '@css/toast.css';
import { reactErrorHandler } from '@sentry/react';
import '@src/index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// `pnpm dev:mock` serves the app against the in-browser API mock. The import is
// behind a build-time flag, so other builds don't bundle MSW.
async function enableMocking() {
  if (import.meta.env.VITE_MSW !== 'true') {
    return;
  }

  const { startMockWorker } = await import('@src/___mocks___/browser');
  await startMockWorker();
}

// If the worker can't start (e.g. a stale public/mockServiceWorker.js), say so
// instead of leaving a blank page; the app then calls the real backend.
await enableMocking().catch((error: unknown) => {
  console.error('[mock] MSW failed to start; API calls are not mocked.', error);
});

createRoot(document.getElementById('root')!, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: reactErrorHandler(),
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
